<div fxLayout="row" fxLayoutAlign="space-between center" class="top-row">
    <div fxLayout="row wrap" fxLayoutGap="20px" fxFlex fxLayoutAlign="start center" [ngClass]="{'disableBillingPeriod': showNullData}">
        <div class="txt-p-16-4">{{'Period'|i18n}}:</div>
        <app-ec-billing-filter [config]="config"
                               [billingPeriod]="billingPeriod"
                               [useFilter]="useFilter"
                               (billingPeriodChange)="onChangeBillingPeriod($event)">
        </app-ec-billing-filter>
    </div>
    <div fxLayout="row wrap" fxFlex="35" fxLayoutAlign="end center" class="lift">
        <button app-primary-button class="mt-10 mr-10" *ngIf="showGSEBtn"
                [disabled]="isGSEDisabled"
                (click)="onClickEnterGseData()">
            <app-icon name="fal-pen"></app-icon>
            {{'Enter GSE data'|i18n}}
        </button>
        <button *ngIf="response" app-ghost-button class="mt-10 mr-10" (click)="exportEconomicsToExcel()"
                [disabled]="templateIsDownloading">
            <app-icon class="excel-icon" name="fal-file-excel"></app-icon>
        </button>
    </div>
</div>
